import { useContext } from 'react'
import { useTranslation } from 'react-i18next'

import { GapBox } from 'components/Box'
import { Form } from 'components/Form'
import { SectionHeader } from 'components/Header'
import Paper from 'components/Paper'
import { WorkspaceBidderContext } from 'features/globalSetup/contexts/WorkspaceBidderContext'
import { FormBody } from './components/FormBody'
import { defaults, schema, Schema } from './form/schema'
import { useUpdateDomainBidder } from './hooks/useUpdateDomainBidder'

export const BidParamsAndConnection = (): React.JSX.Element => {
  const { t } = useTranslation('features/globalSetup', {
    keyPrefix: 'prebid.bidders.edit.bidParamsAndConnection',
  })

  const { currentDomainBidder, formId, setTouched, setValid } = useContext(WorkspaceBidderContext)
  const { errors: apiErrors, update } = useUpdateDomainBidder()

  const requiredOff: boolean =
    currentDomainBidder?.csParamsSchema.some(({ requiredOff }) => requiredOff) ?? false

  return (
    <Paper>
      <SectionHeader
        subtitle={t(`description.${requiredOff ? 'conditional' : 'required'}`)}
        title={t('title')}
      />

      <GapBox />

      <Form<Schema>
        externalErrors={apiErrors}
        id={formId}
        onSubmit={update}
        onTouched={setTouched}
        onValid={setValid}
        schema={schema}
        schemaDefaults={defaults}
      >
        {() => <FormBody />}
      </Form>
    </Paper>
  )
}
